module.exports = {"430405007":"衡州路街道","430405009":"广东路街道","430405010":"东风路街道","430405011":"冶金街道","430405012":"苗圃街道","430405013":"粤汉街道","430405014":"东阳渡街道","430405100":"茶山坳镇","430405200":"和平乡","430405201":"酃湖乡","430405400":"金甲岭农场","430405403":"松林茶场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430405.json
// module id = 1833
// module chunks = 0